import { GuiBase } from "../GuiBase";

export class GuiLoginMandant extends GuiBase {

    constructor() {
        super("Login");
    }

}
